import axios from "axios";
import { useState } from "react";
import { FaCheckSquare, FaExclamationCircle, FaExclamationTriangle } from "react-icons/fa";
import { useParams } from "react-router-dom";
import HostSpecificInstructions from "../register/hosts/HostSpecificInstructions";

export default function NoMeasurement({ show }) {
    const { accountID } = useParams();
    const [scanScheduled, setScanScheduled] = useState();
    const scanFeed = event => {
        event.preventDefault();
        axios.post(`/api/${accountID}/feedscan/${show.showID}`);
        setScanScheduled(true);
    };
    if (show.hasMeasurment) return null;

    return show.redirectActive ? (
        <>
            <h2 style={{ margin: "0 0 0.5rem" }}>
                <FaCheckSquare style={{ fill: "green", verticalAlign: "-0.125em" }} /> Successfully
                Registered
            </h2>
            <h2 style={{ margin: "0 0 0.5rem" }}>
                <FaCheckSquare style={{ fill: "green", verticalAlign: "-0.125em" }} /> Podtrac
                redirect detected in your RSS feed
            </h2>
            <p>
                <b>Next step:</b> check back in 1 to 2 days.
            </p>
            <p>
                It takes 24 to 48 hours for data to become available once the redirect has been
                detected.
            </p>
        </>
    ) : (
        <>
            <h2 style={{ margin: "0 0 0.5rem" }}>
                <FaCheckSquare style={{ fill: "green", verticalAlign: "-0.125em" }} /> Successfully
                Registered
            </h2>
            <p>
                <b>Next step:</b> add the Podtrac redirect to your RSS feed.
            </p>

            <div
                style={{
                    padding: "1rem 0 0",
                    margin: "1rem 0",
                    borderTop: "1px solid #ddd",
                    borderBottom: "1px solid #ddd"
                }}
            >
                <HostSpecificInstructions host={show.host} />
            </div>

            <p>
                Once you add the Podtrac redirect to your feed Podtrac will pick up the changes by
                scanning your feed overnight. To scan the feed sooner, click the button below:
            </p>
            <p>
                <button onClick={scanFeed}>Scan my feed now</button>{" "}
                {scanScheduled ? <b>Feed scan scheduled. Check back in a few minutes.</b> : null}
            </p>

            <p>
                Once your feed is scanned you will begin to see data on your Podtrac dashboard in 24
                to 48 hours.
            </p>
        </>
    );
}
